import { render } from "./TheIdle.vue?vue&type=template&id=fa981830"
import script from "./TheIdle.vue?vue&type=script&lang=js"
export * from "./TheIdle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__